import { ReactComponent as GiftCardIconSVG } from '@/assets/icons/GiftCardIcon.svg';
import { SVGProps } from 'react';

const GiftCardIcon = (props: SVGProps<SVGSVGElement>) => <GiftCardIconSVG {...props} />;

export default GiftCardIcon;
